import { render, staticRenderFns } from "./CommentTextarea.vue?vue&type=template&id=6e18f69c&"
import script from "./CommentTextarea.vue?vue&type=script&lang=js&"
export * from "./CommentTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CommentTextarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VTextarea})
